import { useEffect, useState } from "react"
import { useDispatch } from "react-redux"
import styled from "styled-components"
import { getLogsModulesWithOperation } from "../../features/log/logSlice"
// import { GetLogsByCompanyIdQuery, getLogsModulesWithOperation } from "../../features/log/logSlice"
//             import Datetime from 'react-datetime';
// import 'react-datetime/css/react-datetime.css';
// import DatePicker from "react-datepicker";
// import "react-datepicker/dist/react-datepicker.css";
const Container = styled.div`

    width: 100%;
    height: auto;
    min-height: 100vh;

    .wrapper{
        padding: 30px;

        .top-container{
            width: 100%;
            border-bottom: 1px solid ${({theme}) => theme.mainBorderColor};

            h1{
                font-size: 20px;
                font-weight: 500;
            }
        }
    }

 


`

const dateFilter = [
    {
        id:1,
        text: "Son 5 dakika"
    },
    {
        id:2,
        text: "Son 10 dakika"
    },
    {
        id:3,
        text: "Son 30 dakika"
    },
    {
        id:4,
        text: "Son 1 saat"
    },
    {
        id:5,
        text: "Son 3 saat"
    },
    {
        id:6,
        text: "Son 6 saat"
    },
    {
        id:7,
        text: "Son 12 saat"
    },
    {
        id:8,
        text: "Son 24 saat"
    },
    {
        id:9,
        text: "Son 2 Gün"
    },
    {
        id:10,
        text: "Son 7 Gün"
    },
    {
        id:11,
        text: "Son 30 Gün"
    },
    {
        id:12,
        text: "Son 90 Gün"
    },
    {
        id:13,
        text: "Son 6 Ay"
    },
    {
        id:14,
        text: "Son 1 yıl"
    },
]

  const LogPanel = () => {

    const dispatch = useDispatch()

    const [fromDateTime, setFromDateTime] = useState("")
    const [toDateTime, setToDateTime] = useState("")
    const [operationType, setOperationType] = useState(null)
    const [limit, setLimit] = useState(100)
    const [shipmentId, setShipmentId] = useState(null)

    const [value, setValue] = useState("")


    useEffect(() => {
        dispatch(getLogsModulesWithOperation())
    },[])


  return (
    <Container>
        <div className="wrapper">
            <div className="top-container">
                <h1>Log Panel</h1>
            </div>


{/* <Datetime
  value={value}
  onChange={setValue}
  inputProps={{ placeholder: 'Tarih ve saat seçin' }}
/>

<DatePicker
  selected={fromDateTime}
  onChange={(date) => setFromDateTime(date)}
  showTimeSelect
  timeFormat="HH:mm"
  timeIntervals={15}
  dateFormat="dd/MM/yyyy HH:mm"
  className="my-date-picker"
/> */}
        </div>

    </Container>
  )
}

export default LogPanel